window.addEventListener("DOMContentLoaded", () =>{
    const hiddenField = $("input[type='hidden'][name='document_apply_url_redirect']");
    if (hiddenField.length) {
        const redirect_url: string = String(hiddenField.val());
        window.open(redirect_url);
    }
});